import { CurrencyCode } from 'further-types/lp/vehicle';
import { Control } from 'react-hook-form';
import ReceivedConsiderationRow from './ConsiderationRows/ReceivedConsiderationRow';
import EscrowConsiderationRow from './ConsiderationRows/EscrowConsiderationRow';
import EarnoutConsiderationRow from './ConsiderationRows/EarnoutConsiderationRow';
import WithholdingTaxConsiderationRow from './ConsiderationRows/WithholdingTaxConsiderationRow';
import { realisation as rules } from 'further-ui/validations';
import { Card, CardContent } from '@mui/material';
import { Column } from 'further-ui/components/Layout';

type Props = {
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  currencyCode: CurrencyCode;
  disabled: boolean;
};

const ProRataConsiderationForm: React.FC<Props> = ({
  control,
  index,
  currencyCode,
  disabled,
}) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Column spacing="xl">
          <ReceivedConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
          <EscrowConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
          <EarnoutConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
          <WithholdingTaxConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
        </Column>
      </CardContent>
    </Card>
  );
};

export default ProRataConsiderationForm;
